import { ROLE_LABELS } from "../../../services/navigation";

export default function RoleCheckboxes({ value = [], onChange, directReportCount = 0, disabled = false }) {
  const selected = new Set(["employee", ...value]);
  const toggle = (key) => {
    const next = new Set(selected);
    if (next.has(key)) next.delete(key); else next.add(key);
    next.add("employee");
    onChange([...next]);
  };
  const managerLocked = directReportCount > 0 && selected.has("manager");
  return (
    <fieldset className="role-checkboxes" disabled={disabled}>
      <legend className="sr-only">Application roles</legend>
      {Object.entries(ROLE_LABELS).map(([key, label]) => {
        const locked = key === "employee" || (key === "manager" && managerLocked);
        return (
          <label key={key} className="checkbox-row">
            <input type="checkbox" checked={selected.has(key)} disabled={locked} onChange={() => toggle(key)} />
            <span>{label}</span>
            {key === "employee" && <small className="muted"> (always kept)</small>}
            {key === "manager" && managerLocked && (
              <small className="muted"> (has {directReportCount} direct report{directReportCount === 1 ? "" : "s"}; move them to another manager first)</small>
            )}
          </label>
        );
      })}
    </fieldset>
  );
}

export const roleListLabel = (keys = []) => Object.entries(ROLE_LABELS).filter(([k]) => keys.includes(k)).map(([, v]) => v).join(", ") || "Employee";
